import { useEffect } from 'react';
import { BeforeYouStartTemplate, ContentBody } from '@templates';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RoutesList } from '@waste/routes/Routes';
import { useWasteStore } from '@waste/store/store';
import { CallToActionCardProps } from '@molecules/';
import {
  FORM_LINK_TEXT,
  FORM_LINK_SUBTEXT,
  CHAT_LINK_TEXT,
  CHAT_LINK_SUBTEXT,
} from '@constants';

const ASSISTANT_URL = import.meta.env.VITE_ASSISTANT_URL;

export const BeforeYouStart = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // If, for some unknown reason, a user comes in without a category in the url, the default category will be dog_poo.
  // As otherwise they will see an error on the following page.
  const paramsType = searchParams.get('type') || 'dog_poo';
  const {
    wasteCategory,
    updateWasteCategory,
    updateRenderedWasteCategoryQuestionsAndOptions,
    resetWasteDetails,
    resetAllUploadPhoto,
    resetYourDetails,
    updateSelectedSubcategory,
  } = useWasteStore();
  const contentTitle = 'Report a waste issue';

  const photoUploadRoute = () => {
    navigate(RoutesList.UPLOAD_PHOTO);
  };

  const reportItAssistantRoute = `${ASSISTANT_URL}?category=${wasteCategory}`;
  const assistantCTA: CallToActionCardProps = {
    linkText: CHAT_LINK_TEXT,
    linkSubtext: CHAT_LINK_SUBTEXT,
    externalHref: reportItAssistantRoute,
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: FORM_LINK_TEXT,
    linkSubtext: FORM_LINK_SUBTEXT,
    onClick: photoUploadRoute,
  };

  const callToActionCards = [assistantCTA, reportItCTA];
  const linkObjectArrays = [
    {
      level: 1,
      title: 'Home',
      href: 'https://www.westminster.gov.uk/',
    },
    {
      level: 2,
      title: 'Report it',
      href: 'https://www.westminster.gov.uk/report-it',
    },
    {
      level: 3,
      title: 'Report a waste issue',
    },
  ];

  const needToKnowContent = {
    sectionTitle: `To help us resolve the issue, we need to know:`,
    itemList: [`details of the issue`, `the location of the issue`],
  };

  const helpfulToIncludeContent = {
    sectionTitle: `It’s useful to provide:`,
    itemList: ['photos of the issue'],
  };

  const bodyContent = [needToKnowContent, helpfulToIncludeContent];

  useEffect(() => {
    if (wasteCategory === '' || (wasteCategory !== '' && paramsType !== null)) {
      updateWasteCategory(paramsType);
      resetWasteDetails();
      resetAllUploadPhoto();
      resetYourDetails();
    }

    updateRenderedWasteCategoryQuestionsAndOptions(undefined);
    updateSelectedSubcategory('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={<ContentBody content={bodyContent} />}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
